import { Controller } from '@hotwired/stimulus'
import List from 'list.js';

export default class extends Controller {
    static targets = ['item', 'listwrapper'];
    static values = {
        single: { type: Boolean, default: true },
    }

    listwrapperTargetConnected(listwrapper) {
        this.list = new List(listwrapper, {
            valueNames: ['handle', 'name', 'age', 'type']
        });
    }

    toggleItem(event) {
        const currentItem = event.target.closest('.item');

        if (this.singleValue) {
            for (const item of this.itemTargets) {
                if (currentItem !== item) {
                    item.classList.remove('show');
                }
            }
        }

        currentItem.classList.toggle('show');

        window.dispatchEvent(new Event('resize'));
    }

    closeItems() {
        for (const item of this.itemTargets) {
            item.classList.remove('show');
        }
    }

    search({ detail }) {
        this.list?.search(detail);
    }

    vote(event) {
        this.dispatch('vote', { detail: event.target.closest('.item').dataset.id ?? null });
    }
}
